

























import Vue from 'vue';
import { ShowFinally } from 'mycorems-app-shared';
import { PaymentMethod } from '../types';
import repository from './payment-method-repository';
import AddPaymentMethodBtn from './AddPaymentMethodBtn.vue';
import SelectPaymentMethod from './SelectPaymentMethod.vue';

interface Data {
  paymentMethods: PaymentMethod[]
  task: Promise<PaymentMethod[]>|null,
}

export default Vue.extend({
  components: { ShowFinally, AddPaymentMethodBtn, SelectPaymentMethod },
  model: {
    event: 'change',
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
    value: String,
  },
  data(): Data {
    return {
      paymentMethods: [],
      task: null,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.findAll(this.customerId);
      this.task.then((paymentMethods: PaymentMethod[]) => {
        this.paymentMethods = paymentMethods;
      });
    },
    add(paymentMethod: PaymentMethod) {
      this.paymentMethods.push(paymentMethod);
      this.$emit('change', paymentMethod.id);
    },
  },
});
